'use strict'

/**
 * External Dependencies
 */
import 'jquery'

import './block-slider'

import './form-parts/index'

import './generated-form'

import './menu'

import './animations'

import './utils/custom-select'

import './posts-filter'

import './subscribe-form'

import './blocks'


const videoContainers = document.querySelectorAll('.video-container')

videoContainers.forEach((element) => {

  const video = element.querySelector('video')
  const button = element.querySelector('button')
  const videoOverlay = element.querySelector('.video-overlay')

  button.addEventListener('click', function () {
    video.play()
    video.setAttribute('controls', true)
    videoOverlay.classList.add('d-none')
  })

})

// wrap all tables
const tables = document.querySelectorAll('.block-post-content table')
tables.forEach(table => {
  $(table).wrap('<div class="overflow-table"></div>')
})


// check service cards
if(window.innerWidth < 772) {
  const serviceLinks = document.querySelectorAll('.card-service .card-link')
  serviceLinks.forEach(link => {

    link.addEventListener('click', (e) => {
      if (!e.target.getAttribute('data-clicked')) {
        e.preventDefault()
      }

      e.target.setAttribute('data-clicked', true)
    })
  })
}
